if (!customElements.get("banner-cards")) {
  customElements.define(
    "banner-cards",
    class BannerCards extends HTMLElement {
      constructor() {
        super();
        this.reviews = this.querySelectorAll(".banner-cards__review");
        this.showMore = this.querySelector(".banner-cards__show-more");
        this.sliderEl = this.querySelector(".banner-cards__slider");

        this.splide = null;
        this.splideWaitRaf = null;
        this.desktopQuery = "(min-width: 768px)";

        // Bind handlers (bind this so that this is always our element even when you call it inside event listener)
        this.initialize = this.initialize.bind(this);
        this.onResizeRaf = null;
        this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        this.handleShowMore();
        this.initialize();
        window.addEventListener("resize", this.handleResize, { passive: true });                
        if (document.readyState !== "complete") {
          window.addEventListener("load", this.initialize, { once: true });
        }
      }

      handleResize() {
        if (this.onResizeRaf) return;
        this.onResizeRaf = requestAnimationFrame(() => {
          this.onResizeRaf = null;
          this.initialize();
        });
      }

      initialize() {
        const shouldHaveSlider = window.innerWidth > 767;

        if (shouldHaveSlider) {
          if (this.sliderEl && !this.splide) {
            this.initSlider(this.sliderEl);
          }
        } else {
          if (this.splide) {
            this.splide.destroy(true);
            this.splide = null;
          }
        }
      }

      waitForSplide(cb, attempts = 0) {
        if (window.Splide) {
          cb();
          return;
        }
 
        if (attempts > 600) return;
        this.splideWaitRaf = requestAnimationFrame(() =>
          this.waitForSplide(cb, attempts + 1)
        );
      }

      handleShowMore() {
        if (!this.showMore) return;

        this.showMore.addEventListener("click", () => {
          let counter = 0;

          for (let i = 0; i < this.reviews.length; i++) {
            const review = this.reviews[i];
            if (review.classList.contains("banner-cards__review-hidden")) {
              review.classList.remove("banner-cards__review-hidden");
              counter++;
              if (counter >= 4) break;
            }
          }

          const hiddenLeft = Array.from(this.reviews).some((r) =>
            r.classList.contains("banner-cards__review-hidden")
          );
          if (!hiddenLeft) {
            this.showMore.style.display = "none";
          }
        });
      }

      initSlider(sliderElement) {
        if (!window.Splide) {
          this.waitForSplide(() => {
            if (window.innerWidth > 767 && !this.splide) {
              this.initSlider(sliderElement);
            }
          });
          return;
        }

        const options = {
          classes: {
            arrows: "splide__arrows",
            arrow: "splide__arrow",
            prev: "splide__arrow--prev custom-prev",
            next: "splide__arrow--next custom-next",
          },
          perMove: 1,
          drag: true,
          pagination: false,
          arrows: true,
          mediaQuery: "max",
          autoWidth: true,
          omitEnd: true,
          trimSpace: true,
        };

        this.splide = new Splide(sliderElement, options);
        this.splide.mount();
      }
    }
  );
} 
